//import axios from 'axios'
import { defineStore } from 'pinia'
// 修正點：必須在這裡加入 computed
//import { ref, computed } from 'vue'
//import axios from 'axios';
//import api from '../utils/axios';
//import TokenService from '../service/token.service';
//import router from '@/router';

export const useUserLoginStore = defineStore('login', {
    
    state: () => ({
        userData: null,
        accesstoken: '',
        refreshtoken: '',
        usertype: '',
    }),
     
    actions: {
        async loginUser(email, password) {
            console.log("Store Action 啟動:", email, password);
            console.log("正在執行 Action...");
            this.usertype = email;
            const router = (await import('@/router')).default;
            router.push('/product');
            
        },
        async logout() {
            this.userData = null;
            this.accesstoken = '';
            this.refreshtoken = '';
            this.usertype = 'guest'; // 登出後變回遊客
            const router = (await import('@/router')).default;
            router.push('/');
        }
    },
    getters: {
        checkstate: (state) => state.userData, // Getter 通常用來回傳 state 的處理結果
        isLoggedIn: (state) => !!state.accesstoken, // 新增：判斷是否登入
        storeUsertype: (state) => state.usertype
    },
    persist: {
        key: 'user-login-store',
        storage: localStorage,
        pick: ['userData', 'accesstoken', 'refreshtoken', 'usertype']
    }// ✅ 這裡才是正確的第三參數位置
});


//https://ithelp.ithome.com.tw/articles/10304656
// https://youtu.be/LfWpPRId5N0?si=ESxFVtaGR3DQDKVv